import fetch from './fetchWithTimeout';
import { START_SPINNER, STOP_SPINNER, UPDATE_ERROR } from '../../actions/types';
import { purgeState } from '../../actions/commonActions';
import { MAIN_API_HOST } from './api-config';

export default class BaseBackend {
	constructor(apiBaseUrl, apiKey) {
		this.API_BASE_URL = apiBaseUrl;
		this.API_KEY = apiKey;
	}

	setSessionToken = (sessionToken) => {
		this.SESSION_TOKEN = sessionToken;
	};

  setBaseUrl(host) {
    this.API_BASE_URL = host;
  }

	_fetchJSONFile(remotePath) {
		return fetch(remotePath)
			.then((resp) => {
				return resp.json();
			})
			.catch((err) => {
				return Promise.reject(err);
			});
	}

	_fetchInternal(baseURL, httpMethod, endpoint, data, session, dispatch, showSpinner = true, timeoutInMillis = 60000) {
		let sessiontoken = null;
		if (session) {
			sessiontoken = session;
		}
		let opts = {
			method: httpMethod,
			mode: 'cors',
			cache: 'no-store',
			//credentials: 'include'
		};
		if (httpMethod) opts.method = httpMethod;
		opts.url = baseURL + endpoint;
		opts.headers = {};
		opts.headers['Content-Type'] = 'application/json';
		opts.headers['x-dentalcorp-api-key'] = this.API_KEY;

		if (sessiontoken) opts.headers['x-dentalcorp-sessiontoken'] = sessiontoken;

		if (data) {
			opts.body = JSON.stringify(data);
		}
		showSpinner && dispatch({ type: START_SPINNER });
		return fetch(opts.url, opts, timeoutInMillis)
			.then((resp) => {
				if (resp.status === 401) {
					let err = new Error('Session expired. Please login again.');
					err.code = 1001;
					dispatch(purgeState());
					return Promise.reject(err);
				}
				return resp.json();
			})
			.then((body) => {
				if (!body.ok) {
					let err = new Error(body.error.reason);
					err.code = body.error.code;
					dispatch({
						type: UPDATE_ERROR,
						payload: {
							flag: true,
							reason: body.error.reason,
						},
					});
					return Promise.reject(err);
				}
				showSpinner && dispatch({ type: STOP_SPINNER });
				return Promise.resolve(body);
			})
			.catch((err) => {
				showSpinner && dispatch({ type: STOP_SPINNER });
				dispatch({
					type: UPDATE_ERROR,
					payload: {
						flag: true,
						reason: err.message,
					},
				});
				return Promise.reject(err);
			});
	}

	async _fetch(httpMethod, endpoint, data, session, dispatch, showSpinner = true, timeoutInMillis) {
		return await this._fetchInternal(this.API_BASE_URL, httpMethod, endpoint, data, session, dispatch, showSpinner, timeoutInMillis);
	}

	async _fetchCustomBase(baseURL, httpMethod, endpoint, data, session, dispatch, showSpinner = true) {
		return await this._fetchInternal(baseURL, httpMethod, endpoint, data, session, dispatch, showSpinner);
	}

	// async _fetchExternal(httpMethod, endpoint) {
	//     let opts = {
	//         method: httpMethod,
	//         mode: 'cors',
	//         cache: 'no-store'
	//         //credentials: 'include'
	//     };

	//     if (httpMethod)
	//         opts.method = httpMethod;

	//     console.log(endpoint);
	//     opts.url = endpoint;
	//     opts.headers = {};
	//     //opts.headers = {'Access-Control-Allow-Origin': '*'};
	//     //opts.headers['Content-Type'] = 'application/json';
	//     //opts.headers['Access-Control-Allow-Credentials'] = true;
	//     //opts.headers['Access-Control-Allow-Origin'] = '*';
	//     //opts.headers['Access-Control-Allow-Methods'] = 'GET';
	//     //opts.headers['Access-Control-Allow-Headers'] = 'application/json';
	//     opts.headers['origin'] = '*'
	//     opts.headers['Host'] = 'www.zipcodeapi.com'

	//     console.log('Calling Search: ', opts);

	//     return fetch(opts.url, opts)
	//         .then(resp => {
	//             console.log('Calling 1 ', resp);
	//             return resp.json();
	//         })
	//         .then(body => {
	//             console.log('Calling 2 ', body);
	//             return Promise.resolve(body);
	//         })
	//         .catch(err => {
	//             return Promise.reject(err);
	//         });
	// }

	_uploadImage(httpMethod, endpoint, data, session, timeoutInMillis, dispatch, showSpinner = true) {
		let sessiontoken = null;
		if (session) {
			sessiontoken = session;
		}
		let opts = {
			method: httpMethod,
		};
		let formData = new FormData();
		formData.append('file', data);

		opts.url = MAIN_API_HOST + endpoint;
		opts.headers = {};
		opts.headers['x-dentalcorp-api-key'] = 'fb4a6b72-a08a-4331-8d95-c7046ec6cd22';

		if (sessiontoken) opts.headers['x-dentalcorp-sessiontoken'] = sessiontoken;

		if (formData) {
			opts.body = formData;
		}
		showSpinner && dispatch({ type: START_SPINNER });
		return fetch(opts.url, opts, timeoutInMillis)
			.then((resp) => {
				return resp.json();
			})
			.then((body) => {
				if (!body.ok) {
					let err = new Error(body.error.reason);
					err.code = body.error.code;
					return Promise.reject(err);
				}
				showSpinner && dispatch({ type: STOP_SPINNER });
				return Promise.resolve(body);
			})
			.catch((err) => {
				showSpinner && dispatch({ type: STOP_SPINNER });
				dispatch({
					type: UPDATE_ERROR,
					payload: {
						flag: true,
						reason: err.message,
					},
				});
				return Promise.reject(err);
			});
	}

	_uploadFileInternal(baseURL, httpMethod, endpoint, data, type, session, timeoutInMillis, dispatch, showSpinner = true) {
		let sessiontoken = null;
		if (session) {
			sessiontoken = session;
		}
		let opts = {
			method: httpMethod,
			mode: 'cors',
			cache: 'no-store',
		};

		opts.url = baseURL + endpoint;
		opts.headers = {};
		opts.headers['x-dentalcorp-api-key'] = 'fb4a6b72-a08a-4331-8d95-c7046ec6cd22';
		if (type) opts.headers['Content-Type'] = type;

		if (sessiontoken) opts.headers['x-dentalcorp-sessiontoken'] = sessiontoken;

		if (data) {
			opts.body = data;
		}

		showSpinner && dispatch({ type: START_SPINNER });
		return fetch(opts.url, opts, timeoutInMillis)
			.then((resp) => {
				return resp.json();
			})
			.then((body) => {
				if (!body.ok) {
					let err = new Error(body.error.reason);
					err.code = body.error.code;
					return Promise.reject(err);
				}
				showSpinner && dispatch({ type: STOP_SPINNER });
				return Promise.resolve(body);
			})
			.catch((err) => {
				showSpinner && dispatch({ type: STOP_SPINNER });
				dispatch({
					type: UPDATE_ERROR,
					payload: {
						flag: true,
						reason: err.message,
					},
				});
				return Promise.reject(err);
			});
	}

	async _uploadFile(httpMethod, endpoint, data, type, session, timeoutInMillis, dispatch, showSpinner = true) {
		return await this._uploadFileInternal(this.API_BASE_URL, httpMethod, endpoint, data, type, session, timeoutInMillis, dispatch, showSpinner);
	}

	async _uploadFileCustomBase(baseURL, httpMethod, endpoint, data, type, session, timeoutInMillis, dispatch, showSpinner = true) {
		return await this._uploadFileInternal(baseURL, httpMethod, endpoint, data, type, session, timeoutInMillis, dispatch, showSpinner);
	}

	_fetchDentira(httpMethod, endpoint, data, session, timeoutInMillis, dispatch, showSpinner = true) {
		let sessiontoken = null;
		if (session) {
			sessiontoken = session;
		}
		let opts = {
			method: httpMethod,
		};
		opts.url = MAIN_API_HOST + endpoint;
		opts.headers = {};
		opts.headers['Content-Type'] = 'application/json';
		opts.headers['x-dentalcorp-api-key'] = this.API_KEY;

		if (sessiontoken) opts.headers['x-dentalcorp-sessiontoken'] = sessiontoken;

		if (data) {
			opts.body = JSON.stringify(data);
		}
		showSpinner && dispatch({ type: START_SPINNER });
		return fetch(opts.url, opts, timeoutInMillis)
			.then((resp) => {
				if (resp.status === 401) {
					let err = new Error('Session expired. Please login again.');
					err.code = 1001;
					dispatch(purgeState());
					return Promise.reject(err);
				}
				return resp.json();
			})
			.then((body) => {
				if (!body.ok) {
					let err = new Error(body.error.reason);
					err.code = body.error.code;
					dispatch({
						type: UPDATE_ERROR,
						payload: {
							flag: true,
							reason: body.error.reason,
						},
					});
					return Promise.reject(err);
				}
				showSpinner && dispatch({ type: STOP_SPINNER });
				return Promise.resolve(body);
			})
			.catch((err) => {
				showSpinner && dispatch({ type: STOP_SPINNER });
				dispatch({
					type: UPDATE_ERROR,
					payload: {
						flag: true,
						reason: err.message,
					},
				});
				return Promise.reject(err);
			});
	}

	// _upload(httpMethod, endpoint, file, state, progressCallback, doneCallback) {
	//     /*
	//      var xhr = new XMLHttpRequest();
	//      xhr.open(httpMethod, 'http://hamletqa.zip.pr/hamlet/main/image', true);
	//      xhr.setRequestHeader("Content-type", "multipart/form-data");

	//      xhr.onload = handler;

	//      function handler() {
	//      if (this.status == 200) {
	//      console.log('done');
	//      doneCallback();
	//      } else {
	//      console.log('some error occurred');
	//      }
	//      }

	//      xhr.upload.onprogress = function (e) {
	//      let percentProgress = 0;
	//      if (e.lengthComputable) {
	//      percentProgress = (e.loaded / e.total) * 100;
	//      console.log(percentProgress);
	//      if (progressCallback) {
	//      progressCallback(percentProgress);
	//      }
	//      }
	//      };

	//      console.log('sending file');
	//      console.log(file);
	//      xhr.send(file);
	//      */

	//     let data = new FormData();
	//     data.append("image", file);
	//     let xhr = new XMLHttpRequest();
	//     //xhr.withCredentials = true;

	//     xhr.addEventListener("readystatechange", function () {
	//         if (this.readyState === 4) {
	//             console.log(this.responseText);
	//             let json = JSON.parse(this.responseText);
	//             if (doneCallback) {
	//                 doneCallback(json.response.image_url);
	//             }
	//         }
	//     });

	//     xhr.upload.onprogress = function (e) {
	//         console.log(e);
	//         let percentProgress = 0;
	//         if (e.lengthComputable) {
	//             percentProgress = e.loaded / e.total * 100;
	//             if (progressCallback) {
	//                 progressCallback(percentProgress);
	//             }
	//         } else {
	//             console.log('some error occurred');
	//         }
	//     };

	//     xhr.open(httpMethod, "http://hamletqa.zip.pr/hamlet/main/image");
	//     xhr.setRequestHeader("x-dentalcorp-api-key", this.API_KEY);
	//     xhr.setRequestHeader("cache-control", "no-cache");

	//     xhr.send(data);
	// }

	_fetchBlob(baseURL, httpMethod, endpoint, data, session, fileName, timeoutInMillis, dispatch, showSpinner = true) {
		let sessiontoken = null;
		if (session) {
			sessiontoken = session;
		}

		let opts = {
			method: httpMethod,
			mode: 'cors',
			cache: 'no-store',
			//credentials: 'include'
		};
		if (httpMethod) opts.method = httpMethod;

		opts.url = baseURL + endpoint;
		opts.headers = {};
		opts.headers['Content-Type'] = 'application/json';
		opts.headers['x-dentalcorp-api-key'] = this.API_KEY;

		if (sessiontoken) {
			opts.headers['x-dentalcorp-sessiontoken'] = sessiontoken;
		}

		if (data) {
			opts.body = JSON.stringify(data);
		}

		showSpinner && dispatch({ type: START_SPINNER });
		return fetch(opts.url, opts, timeoutInMillis)
			.then(async (resp) => {
				const contentType = resp.headers.get('content-type');
				if (contentType && contentType.indexOf('application/json') !== -1) {
					return { data: await resp.json(), type: 'application/json' };
				} else {
					return { data: await resp.blob(), type: 'application/pdf' };
				}
			})
			.then((returnedResponse) => {
				if (returnedResponse.type === 'application/json') {
					let body = returnedResponse.data;
					if (!body.ok) {
						let err = new Error(body.error.reason);
						console.log('debug', err.toString());
						err.code = body.error.code;
						return Promise.reject(err);
					}
				} else {
					let url = window.URL.createObjectURL(returnedResponse.data);
					let a = document.createElement('a');
					a.href = url;
					a.download = fileName ? fileName : data ? `${data.order_id}.pdf` : 'invoice.pdf';
					document.body.appendChild(a);
					a.click();
					a.remove();
				}
				showSpinner && dispatch({ type: STOP_SPINNER });
			})
			.catch((err) => {
				showSpinner && dispatch({ type: STOP_SPINNER });
				console.warn('ERR', err);
				return Promise.reject(err);
			});
	}
}
